<template>
    <div class="roothome_m" style="background-color: var(--main-bg-color-new)">

        <div class="wrapper">
            <!-- ################    Top Menu Bar    ################# -->
            <div align="center" class="head0" style="box-shadow: unset;">
                <div align="center" class="head0_2m">
                    <div class="head1m">
                        <img src="/static/imgs/ic_back_w.png" alt="menu" class="im_menu2" @click="goToBack()" onMouseOver="this.style.cursor='pointer'">
                    </div>
                    <div class="head2m">
                        <span class="tx_logol" >{{ getInterText(inter_ind.quem_somos) }}</span>
                    </div>
                <div  class="head3m">

                    <div v-if="!user.sucess" class="di_profile" @click="setShowLogin(true)">
                        <img src="/static/imgs/ic_profile2.png" alt="profile" class="im_profile_m2">
                    </div>

                    <div v-else class="di_profile" @click="showPopEscritorio()">
                        <div v-if='user.foto === ""' class="im_profile_m2" style="justify-content: center; align-items: center; background-color: var(--bg-blue)">
                            <span class="tx_initials" >{{ getInitials(user) }}</span>
                        </div>
                        <img id="botao_profile2" v-else-if='hasHttp(user.foto)'  :src='user.foto' alt="profile" class="im_profile_m2">
                        <img id="botao_profile3" v-else :src='baseUrlImg + "PROFILE/" + user.foto'     alt="profile" class="im_profile_m2">
                    </div>
                    <div v-if="showPopupEscritorio" class="di_popescritorio" id="popup_escritorio">
                        <div class="arrow_top"></div>
                        <span class="tx_login_b" >{{ getFirstAndLastWords(user.nome) }}</span>
                        <span class="tx_login" onMouseOver="this.style.cursor='pointer'" @click.prevent.stop="goToMinhaPagina()">{{ getInterText(inter_ind.minha_conta) }}</span>
                        <span class="tx_login" onMouseOver="this.style.cursor='pointer'" @click="goToPagina('mEditUser')">{{ getInterText(inter_ind.configuracoes) }}</span>
                        <span class="tx_login" onMouseOver="this.style.cursor='pointer'" @click="logout()">{{ getInterText(inter_ind.sair) }}</span>
                    </div>
                </div>
                </div>
            </div>

            <span class="tx_visao_bg">{{ getInterText(inter_ind.visao) }}</span>

            <div class="div_quem1">
                <span style="font-weight: bold; font-size: 4vw; margin-top: 3vh;">
                    {{ getInterText(inter_ind.quem_somos_p1) }}
                </span>
                <span style="font-size: 3vw; margin-top: 1vh">
                    {{ getInterText(inter_ind.quem_somos_p2) }}
                </span>
                <span style="font-weight: bold; font-size: 4vw; margin-top: 2vh;">
                    {{ getInterText(inter_ind.quem_somos_p3) }}
                </span>
                <span style="font-size: 3vw; margin-top: 1vh">
                    {{ getInterText(inter_ind.quem_somos_p4) }}
                </span>
            </div>

            <div class="div_quem2">
                <div class="div_quem2_2">
                    <span class="tx_pilares">
                        {{ getInterText(inter_ind.pilares) }}
                    </span>
                    <span style="font-weight: bold; font-size: 4vw; margin-top: 0vh;">
                        {{ getInterText(inter_ind.quem_somos_p5) }}
                    </span>
                    <span style="font-size: 3vw; margin-top: 1vh">
                        {{ getInterText(inter_ind.quem_somos_p6) }}
                    </span>
                    <span style="font-weight: bold; font-size: 4vw; margin-top: 2vh;">
                        {{ getInterText(inter_ind.quem_somos_p7) }}
                    </span>
                    <span style="font-size: 3vw; margin-top: 1vh">
                        {{ getInterText(inter_ind.quem_somos_p8) }}
                    </span>
                    <span style="font-weight: bold; font-size: 4vw; margin-top: 2vh;">
                        {{ getInterText(inter_ind.quem_somos_p9) }}
                    </span>
                    <span style="font-size: 3vw; margin-top: 1vh">
                        {{ getInterText(inter_ind.quem_somos_p10) }}
                    </span>
                    <span style="font-weight: bold; font-size: 4vw; margin-top: 2vh;">
                        {{ getInterText(inter_ind.quem_somos_p11) }}
                    </span>
                    <span style="font-size: 3vw; margin-top: 1vh">
                        {{ getInterText(inter_ind.quem_somos_p12) }}
                    </span>
                    <img src="/static/imgs/advicep_horizontal_w.png" style="height: 7vh; object-fit: contain; margin-top: 6vh; margin-bottom: 3vh"/>
                </div>
            </div>
        </div>




        <div class="div_login_m" v-if="showLogin" >
            <div class="parts_m">
                <div style="display: flex; justify-content: flex-end; width: 100%;" @click="setShowLogin(false)">
                    <img src="/static/imgs/bt_fechar_w.png" class="im_close_w" onMouseOver="this.style.cursor='pointer'">
                </div>

                <div style="text-align: center; margin-top: 5vh;">
                    <img src="/static/imgs/advicep_horizontal_w.png" alt="menu" style="height: 8vh">
                </div>





                <!--<div class="div_face_w" style="margin-top: 10vh;">-->
                    <!--<div class="div_faceim">-->
                        <!--<img src="/static/imgs/ic_face_blue.png" alt="facebook" class="im_face">-->
                    <!--</div>-->

                    <!--<div class="div_facetx">-->
                        <!--<span class="tx_face_m"> {{ getInterText(inter_ind.entre_face) }} </span>-->
                    <!--</div>-->
                <!--</div>-->


                <div v-if="!isiOS()"  class="div_face_w" style="margin-top: 8vh; margin-bottom: 5vh" @click="externalLoginGoogle_startApp()">
                <!--<div class="div_face_w" style="margin-top: 1vh; margin-bottom: 5vh">-->
                    <div class="div_faceim">
                        <img src="/static/imgs/ic_google.png" alt="facebook" class="im_face">
                    </div>

                    <div class="div_facetx">
                        <span class="tx_face_m unselectable"> {{ getInterText(inter_ind.entre_google) }} </span>
                    </div>
                </div>
                <div v-else style="height: 12vh;"/>




                <div class="div_nome_l">
                    <span class="tx_nome_before_w" @click="clickInput(1, true)" v-if="!editing[1].status" onMouseOver="this.style.cursor='pointer'" tabindex="2">E-mail</span>
                    <div class="hr_w" @click="clickInput(1, true)" onMouseOver="this.style.cursor='pointer'" v-if="!editing[1].status"/>
                    <span class="tx_nome_w" @click="clickInput(1, false)" v-if="editing[1].status">E-mail</span>
                    <input id="emailid" class="input_name_w" type="text" v-model="editing[1].texto" v-if="editing[1].status" tabindex="3"/>
                    <span v-if="!checkEmail(editing[1].texto) && editing[1].texto.length>5" class="error_msg">{{ getInterText(inter_ind.email_invalido) }}</span>
                </div>

                <div class="div_nome_l">
                    <span class="tx_nome_before_w" @click="clickInput(0, true)" v-if="!editing[0].status" onMouseOver="this.style.cursor='pointer'"> {{ getInterText(inter_ind.senha) }} </span>
                    <div class="hr_w" @click="clickInput(0, true)" onMouseOver="this.style.cursor='pointer'" v-if="!editing[0].status"/>
                    <span class="tx_nome_w" @click="clickInput(0, false)" v-if="editing[0].status"> {{ getInterText(inter_ind.senha) }} </span>
                    <input id="nameid" class="input_name_w" type="password" v-model="editing[0].texto" v-if="editing[0].status" tabindex="4"/>
                    <span v-if="!checkPass(editing[0].texto) && editing[0].texto!=''" class="error_msg">{{ getInterText(inter_ind.senha_errada) }}</span>
                </div>

                <div class="div_check" style="margin-top: 4vh;">
                    <div class="div_check_in" @click="changeCheckState(0)">
                        <span v-if="valid.enterAuto" class="tx_checkbox">&#10003;</span>
                    </div>
                    <span class="tx_check" style="flex-grow: 1; text-align: left;">{{ getInterText(inter_ind.entrar_auto) }}</span>
                    <span class="tx_check" style="cursor: pointer;">{{ getInterText(inter_ind.esqueceu_senha) }}</span>
                </div>

                <span v-if="senhaErrada" class="error_msg">{{ getInterText(inter_ind.senha_errada_2) }}</span>

                <img v-if="loading.user" src="/static/imgs/loading5.gif" alt="Carregando" class="im_loading_up">

                <div style="display: flex; flex-direction: row; margin-top: 10vh">
                    <div class="div_botao_login" style="margin-right: 2vw; background-color: white;" @click="tryLogin()" onMouseOver="this.style.cursor='pointer'" tabindex="4">
                        <span class="tx_continuar unselectable" style="color: var(--bg-blue);"> {{ getInterText(inter_ind.entrar) }} </span>
                    </div>
                    <router-link :to="{ params: { stabs: estabs_full, categs: cats_full, idCat: idCat}, name: 'mRegisterUser'}">
                        <div class="div_botao_login">
                            <span class="tx_continuar_w unselectable" > {{ getInterText(inter_ind.cadastre) }} </span>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import { advMixin } from '../scripts/advMixin'

    export default {
        mixins: [advMixin],
        name: 'mVisao',
        data () {
            return {

            }
        },
        methods: {

        },
        created() {
            console.log(this.name + '::created!!');

            if (this.$route.params.stabs) {
                console.log('Usando estabs e cats passados por parametro!!');
                this.estabs_full = this.$route.params.stabs;
                this.cats_full = this.$route.params.categs;
                if (this.$route.params.idCat != null) {
                    this.idCat = this.$route.params.idCat;
                }
            }

            console.log(this.name + '::Terminei o created!!');
        },
        beforeMount() {
            console.log(this.name + 'beforeMount!!');

            console.log(this.name + 'Terminei o beforeMount!!');
        },
        mounted() {
            console.log(this.name + 'mounted::!!');

            console.log('mMinhaPagina::Terminei o mounted!!');
        },
    }
</script>


<style src="../assets/css/adv.css" scoped/>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .tx_visao_bg {
        width: 100%;
        /*margin-top: var(--top-bar-heigth);*/
        font-family: Humanst521BT;
        font-size: 28vw;
        font-weight: bold;
        color: var(--blue-font-back);
        display: flex;
        /*background-color: red;*/
        position: absolute;
        z-index: 0;
        justify-content: center;
        overflow:hidden
    }

    .div_quem1, .div_quem2 {
        position: relative;
        height: auto;
        z-index: 1;
        /*background-color: red;*/
        font-family: Humanst521BT;
        font-size: 2.5vh;
        display: flex;
        flex-direction: column;
    }

    .div_quem1 {
        padding-right: 5vw;
        padding-left: 5vw;
        margin-top: var(--top-bar-heigth);
        color: var(--bg-blue);
        margin-bottom: 2vh;
    }
    .div_quem2 {
        padding-top: 60vh;
        background-image: url('/static/imgs/bg_quemsomos3.jpg');
        background-size: cover;
        background-position: center;
        color: white;
    }
    .div_quem2_2 {
        display: flex;
        flex-direction: column;
        background-color: var(--bg-blue-grad1-t);
        padding-right: 5vw;
        padding-left: 5vw;
    }

    .tx_pilares {
        display: flex;
        justify-content: center;
        font-weight: bold;
        font-size: 21vw;
        margin-top: 0;
        /*background-color: red;*/
        background: -webkit-linear-gradient(var(--blue-font-degrad1), var(--blue-font-degrad2));
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
</style>



// WEBPACK FOOTER //
// src/components/mVisao.vue